import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { URLS, Url } from '@wix/da-url';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import InfoBlock from '@wix/da-ds/pkg/InfoBlock';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import DreamUpIcon16 from '@wix/da-ds/pkg/Icons/16x16/DreamUp';
import useModulePrivileges from '@wix/da-gruser-shared/pkg/hooks/useModulePrivileges';
import useGruser from '@wix/da-gruser-shared/pkg/hooks/useGruser';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { useVerification } from '../../../VerificationPopup/withVerification';
import { isGroup } from '../../../User/helpers';
import { GallectionSourceType } from '../types';
import { useExhibitionistType } from '../hooks';
import { useSubmitUrl } from '../../../utils/hooks/useSubmitUrl';
import s from './ExhibitionistEmpty.scss';
const componentLocale = 'widgets.exhibitionist.empty';
const navigateTo = (url)=>window.location.assign(url);
const ExhibitionistEmpty = ({ moduleId })=>{
    const { t } = useTranslation();
    const { aiContentFilter } = useContext(SessionContext);
    const exhibitionistType = useExhibitionistType();
    const { gruserOwner } = useGruser();
    const { restrictToVerified } = useVerification();
    const { moduleData } = useModuleData(moduleId);
    const modulePrivs = useModulePrivileges(moduleId);
    const SUBMIT_URL = useSubmitUrl(true);
    if (!gruserOwner) {
        return null;
    }
    const { sourceType } = moduleData;
    const isOwner = modulePrivs === null || modulePrivs === void 0 ? void 0 : modulePrivs.edit;
    const { username } = gruserOwner;
    const isGroupProfile = isGroup(gruserOwner);
    const viewer = isOwner ? 'owner' : 'visitor';
    const localePrefix = `${componentLocale}.${sourceType}`;
    const localeUsername = viewer === 'visitor' ? {
        username
    } : undefined;
    const title = t(isGroupProfile && isOwner ? `${componentLocale}.group.title` : `${localePrefix}.${viewer}.title`, localeUsername);
    const subtitle = t(isGroupProfile && isOwner ? `${componentLocale}.group.subtitle` : `${localePrefix}.${viewer}.subtitle`, localeUsername);
    const ownerCTALocale = `${localePrefix}.owner.CTALabel`;
    const extraProps = {};
    switch(sourceType){
        case GallectionSourceType.COLLECTION:
            extraProps['buttonLabel'] = t(ownerCTALocale);
            extraProps['onButtonClick'] = ()=>navigateTo(URLS.ROOT);
            break;
        case GallectionSourceType.ADOPTABLE_BOUGHT:
            extraProps['buttonLabel'] = t(ownerCTALocale);
            extraProps['onButtonClick'] = ()=>navigateTo(URLS.SHOP);
            break;
        case GallectionSourceType.ADOPTABLE_FOR_SALE:
            extraProps['buttonLabel'] = t(ownerCTALocale);
            extraProps['onButtonClick'] = ()=>navigateTo(SUBMIT_URL);
            break;
        default:
            extraProps['buttonLabel'] = t(isGroupProfile && isOwner ? `${componentLocale}.group.CTALabel` : ownerCTALocale);
            extraProps['onButtonClick'] = restrictToVerified('submit', ()=>navigateTo(Url.studio({
                    openSubmitForm: true
                })));
            extraProps['buttonVariant'] = 'approval-green';
            extraProps['biData'] = {
                evid: 704,
                sectionname: 'exhibitionist'
            };
    }
    return /*#__PURE__*/ React.createElement(InfoBlock, _object_spread({
        className: c(s['root'], s[`${exhibitionistType}_${sourceType}`]),
        title: title,
        subtitle: subtitle,
        withButton: isOwner,
        customSecondaryButton: aiContentFilter !== 'suppress' && sourceType === GallectionSourceType.FEATURED_GALLERY && /*#__PURE__*/ React.createElement(GhostButton, {
            variant: "main",
            size: "medium",
            icon: DreamUpIcon16,
            href: Url.dreamupLink()
        }, t(`${localePrefix}.owner.dreamupCta.label`))
    }, extraProps));
};
export default ExhibitionistEmpty;

//# sourceMappingURL=ExhibitionistEmpty.js.map